import $ from 'jquery';
import plugin from '@core/plugins/lib';

const ELEMENT_SELECTOR = '[data-umbraco-form]';
const PLUGIN_NAME = 'JqueryValidateErrorAdjustments';
const LAYOUT_ELEMENT_SELECTOR = '.field-layout__element';
const ERROR_LIST_SELECTOR = 'label.error';
const ELEMENT_CLASS_SELECTOR = '.field-input-option__input';
const INCREASE_DECREASE_ELEMENT_CLASS_SELECTOR = '.field-input-increase-decrease_input';
const ERROR_CLASS = 'error';

class JqueryValidateErrorAdjustments {
	constructor(element, options) {
		this.$element = $(element);
		this.form = element.querySelector('form');
        this.$submitButton = this.$element.find("[type=submit]").not(".cancel");
        this.$inputs = this.$element.find(ELEMENT_CLASS_SELECTOR);
        this.$increaseDecreaseInputs = this.$element.find(INCREASE_DECREASE_ELEMENT_CLASS_SELECTOR);
        this.processIncreaseDecreaseInputs();
        this.processInputs();
        this.watch();
    }

    processIncreaseDecreaseInputs() {
        var mod = this;
        for (var i=0;i<mod.$increaseDecreaseInputs.length;i++) {
            var el = mod.$increaseDecreaseInputs[i];
            var $el = $(el);
            var layoutElement = $el.closest(LAYOUT_ELEMENT_SELECTOR);
            if (layoutElement.length > 0) {
                if ($el.hasClass(ERROR_CLASS)) {
                    var errorElement = $(layoutElement).find(ERROR_LIST_SELECTOR);
                    if (errorElement.length > 0) {
                        $(errorElement).detach().appendTo(layoutElement);
                    }
                }
            }
        }

    }

    processInputs() {
        var mod = this;
        for (var i=0;i<mod.$inputs.length;i++) {
            var el = mod.$inputs[i];
            var $el = $(el);
            var layoutElement = $el.closest(LAYOUT_ELEMENT_SELECTOR);
            if (layoutElement.length > 0) {
                if ($el.hasClass(ERROR_CLASS)) {
                    var errorElement = $(layoutElement).find(ERROR_LIST_SELECTOR);
                    if (errorElement.length > 0) {
                        $(errorElement).detach().appendTo(layoutElement);
                    }
                }
            }
        }
    }

    scrollToFirstError() {
		const errorElements = $(this.form).data('validator').errorList;

		console.log('errorElements',errorElements);
        if (errorElements.length > 0) {
			errorElements[0].element.focus();
        }
    }

    watch() {
        var mod = this;
        this.$submitButton.click(function (evt) {
            mod.processIncreaseDecreaseInputs();
            mod.processInputs();
            mod.scrollToFirstError();
        });

        this.$increaseDecreaseInputs.change(function() {
            mod.processIncreaseDecreaseInputs();
        });

    }
}

JqueryValidateErrorAdjustments.DEFAULTS = {};
plugin(PLUGIN_NAME, JqueryValidateErrorAdjustments);

$(document).ready(() => {
	$(ELEMENT_SELECTOR)[PLUGIN_NAME]();
});



// WEBPACK FOOTER //
// ./client/src/core/components/forms/jquery-validate-error-adjustments.js